import {
  Form,
  FormElementRef,
  FormFetcher,
  FormInput,
  FormSubmitter,
  SubmitButton,
  TablePageLayout,
} from '@kirz/mui-admin';
import SaveIcon from '@mui/icons-material/Save';
import React, { useRef } from 'react';

export function Settings() {
  const formRef = useRef<FormElementRef>(null);

  return (
    <TablePageLayout
      title="Параметры"
      actionContent={
        <SubmitButton
          sx={{ ml: 'auto' }}
          variant="contained"
          loadingPosition="start"
          startIcon={<SaveIcon />}
          formRef={formRef}
          activateOnDirty
        >
          Сохранить
        </SubmitButton>
      }
    >
      <FormSubmitter
        source="settings"
        entityId={{ id: { _eq: 1 } }}
        onSubmit={() => {}}
      >
        <FormFetcher source="settings" entityId={{ id: { _eq: 1 } }}>
          <Form ref={formRef} sx={{ pt: 1 }}>
            <FormInput
              name="initialTokenAmount"
              type="number"
              md={3}
              label="Начальное количество токенов"
              required
            />
            <FormInput
              name="tokenCostPhoto"
              type="number"
              md={3}
              label="Стоимость генерации изображения"
              required
            />
            <FormInput
              name="tokenCostVideo"
              type="number"
              md={3}
              label="Стоимость генерации видео"
              required
            />
            <FormInput
              name="weeklyTokensFree"
              type="number"
              md={3}
              label="[free] Начисляемые токены в неделю"
              required
            />
            <FormInput
              name="weeklyTokensPremium"
              type="number"
              md={3}
              label="[premium] Начисляемые токены в неделю"
              required
            />
          </Form>
        </FormFetcher>
      </FormSubmitter>
    </TablePageLayout>
  );
}
